import React, { ElementType, FC, forwardRef, ForwardedRef, ReactNode } from 'react';
import { Link, LinkProps } from '@mui/material';

export interface FooterLinkProps extends LinkProps<ElementType> {
  /**
   * Displayed navigation text, can be provided as children as well
   */
  label?: ReactNode;
}

/**
 * Component to render styled link in the footer
 */
export const FooterLink: FC<FooterLinkProps> = forwardRef(({ sx, children, label, ...rest }, ref) => {
  return (
    <Link
      sx={{
        // icon and text next to each other
        display: 'inline-flex',
        gap: 1.5,
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '4px 8px',
        // styling
        '&, &:hover': {
          textDecoration: 'underline',
          color: 'common.white',
        },
        // size of icon
        '& .MuiSvgIcon-root': {
          fontSize: '20px',
        },
        ...sx,
      }}
      variant="list"
      ref={ref as ForwardedRef<HTMLAnchorElement>}
      {...rest}
    >
      {children || label}
    </Link>
  );
});
